import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

export default function ScrollHint({ target = "#services", threshold = 300 }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY < threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  const onClick = () => {
    const el = document.querySelector(target);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollBy({ top: window.innerHeight * 0.9, behavior: "smooth" });
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="scroll-hint"
      aria-label="Scroll to see more"
      className={`fixed left-1/2 -translate-x-1/2 z-40 bottom-6 sm:bottom-8 inline-flex items-center gap-2 pl-4 pr-3 py-2 rounded-full bg-white/95 backdrop-blur border border-stone-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 ${
        visible
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none translate-y-2"
      }`}
    >
      <span className="text-xs font-semibold tracking-wider uppercase text-stone-700">
        Keep scrolling
      </span>
      <span className="h-7 w-7 rounded-full bg-teal-700 text-white flex items-center justify-center animate-scroll-bounce">
        <ChevronDown className="h-4 w-4" strokeWidth={2.4} />
      </span>
      <style>{`
        @keyframes scroll-bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(3px); }
        }
        .animate-scroll-bounce {
          animation: scroll-bounce 1.4s ease-in-out infinite;
        }
      `}</style>
    </button>
  );
}
